import type * as React from 'react';

import { cn } from 'utils/cn';

function Kbd({ className, style, ...props }: React.ComponentProps<'kbd'>) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        'inline-flex h-sm2 min-w-sm2 items-center justify-center gap-xxs2 rounded-xSmall border border-border-subtle bg-background-hover px-xs1 font-medium text-body-small leading-exact tracking-normal text-secondary',
        '[[data-slot=tooltip-content]_&]:border-0 [[data-slot=tooltip-content]_&]:bg-primary-inverse/15 [[data-slot=tooltip-content]_&]:text-inherit',
        className,
      )}
      style={{
        fontFamily:
          'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        ...style,
      }}
      {...props}
    />
  );
}

function KbdGroup({ className, ...props }: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot="kbd-group"
      className={cn('inline-flex items-center gap-xxs2', className)}
      {...props}
    />
  );
}

export { Kbd, KbdGroup };
